<template>
  <div class="home">
    <vue-headful title="ITT流体技术" description="ITT流体技术" />
    <div class="container">
      <div class="brand-logo">
        <img v-if="brand.img" :src="'https://itt-ft.effective-wechat.com/storage/' + brand.img" alt="" />
      </div>
      <div class="contents">
        <p class="main-desc">
          {{ brand.desc }}
        </p>
        <div class="blocks" v-for="block in brand.blocks" :key="block.id">
          <div class="title" v-if="block.name != null">{{ block.name }}</div>
          <div v-for="content in block.contents" :key="content.id" class="para">
            <p class="vc" v-if="content.desc != null" v-html="content.desc"></p>
            <p class="img" v-if="content.img && content.video == null">
              <img :src="'https://itt-ft.effective-wechat.com/storage/' + content.img" :style="{ width: content.size + 'px' }" alt="" />
            </p>
            <p class="video" v-if="content.video">
              <video controls :poster="'https://itt-ft.effective-wechat.com/storage/' + content.img" width="100%" :src="'https://itt-ft.effective-wechat.com/storage/' + content.video" />
            </p>
          </div>
        </div>
        <div class="blocks others" v-if="(links && links.length > 0) || (downloads && downloads.length > 0)">
          <template v-if="links && links.length > 0">
            <div class="link-block">
              <p class="t"><img class="icon" src="@/assets/book.png" alt="" /><strong>推荐阅读</strong></p>
              <swiper ref="linkSwiper" :options="swiperOptions">
                <swiper-slide v-for="(l, i) in links" :key="i">
                  <van-row v-for="(link, idx) in l" :key="idx" class="link-more">
                    <van-col span="16">
                      <p class="read-text">
                        <a :href="link.link">{{ link.text }}</a>
                      </p>
                    </van-col>
                    <van-col span="8">
                      <a :href="link.link">
                        <img :src="'https://itt-ft.effective-wechat.com/storage/' + link.img" alt="" />
                      </a>
                    </van-col>
                  </van-row>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
          </template>
          <template v-if="downloads && downloads.length > 0">
            <div class="link-block other-product">
              <p class="t"><img class="icon" src="@/assets/folder.png" alt="" /><strong>相关产品</strong></p>
              <swiper ref="linkSwiper" :options="swiperOptions">
                <swiper-slide v-for="(l, i) in downloads" :key="i">
                  <van-row>
                    <van-col span="8" v-for="(link, idx) in l" :key="idx" class="products">
                      <a :href="link.link"
                        ><img :src="'https://itt-ft.effective-wechat.com/storage/' + link.img" alt="" /> <span class="link-text">{{ link.text }}</span></a
                      >
                    </van-col>
                  </van-row>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="footer">
      <img src="@/assets/footer.png" alt="" />
      <!-- <div class="top"></div>
      <div class="content">
        <div class="qr">
          <img src="@/assets/qr.jpeg" alt="" />
        </div>
        <div class="info">
          <h5>长按左侧二维码关注,了解更多</h5>
          <p>斯必克流体中国</p>
          <p>网址：spxflow.com/cn</p>
          <p>电话：86-21-2208 5888</p>
          <p>售后服务电话：4001-528-008</p>
          <p>邮箱：china.contact@spxflow.com</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { getBrand } from "@/api/request";
import chunk from "lodash/chunk";

export default {
  name: "brand",
  data() {
    return {
      brand: {},
      links: [],
      downloads: [],
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
        },
        // Some Swiper option/callback...
      },
    };
  },
  methods: {},
  async mounted() {
    let brand = await getBrand({ id: this.$route.params.id });
    this.brand = brand.data;
    this.links = chunk(this.brand.links, 3);
    this.downloads = chunk(this.brand.downloads, 3);
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100vw;
  min-height: calc(100vh - 221px);
  .brand-logo {
    img {
      width: 100vw;
      display: block;
    }
  }
  .contents {
    p {
      padding: 30px;
      line-height: 27px;
      letter-spacing: 0;
      color: #535353;
    }
    .main-desc {
      white-space: pre-line;
    }
    .blocks {
      padding: 30px;
      padding-top: 0px;
      text-align: center;

      .para {
        margin-bottom: 10px;
      }

      &.others {
        background-color: #f1eded;
        padding-bottom: 30px;
        padding-top: 10px;
        padding-left: 10px;
        padding-right: 10px;
      }
      .link-block {
        background: #ffffff;
        box-shadow: 0px 0px 4px 0px #c2bfbf;
        border-radius: 5px;
        padding: 5px 15px;
        padding-bottom: 0;
        &.other-product {
          margin-top: 10px;
        }
        .read-text {
          text-align: left;
          width: 100%;
          word-wrap: break-word;
          line-height: 22px;
          a {
            font-size: 14px;
            color: #1d4f48;
          }
        }
        .link-text {
          display: inline-block;
          background-color: #1d4f48;
          color: #fff;
          font-size: 12px;
          width: 80%;
          position: relative;
          bottom: 10px;
        }

        .products {
          img {
            width: 80%;
            margin: 0 auto;
            background-color: #eaeaea;
          }
        }

        .link-more {
          border-bottom: 1px solid #f1eded;

          img {
            margin: 0;
            width: 15vw;
            height: 15vw;
            display: block;
          }
          & .van-col--8 {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            height: 75px;
          }
          & .van-col--16 {
            display: flex;
            height: 75px;
            align-items: center;
          }
          &:last-child {
            border-bottom: none;
          }
        }
        strong {
          display: inline-block;
          color: #1d4f48;
        }
        .t {
          display: flex;
          align-items: center;
          padding-top: 0;
          .icon {
            flex: 0;
            width: 23px;
            margin-left: 2px;
          }
          strong {
            flex: 1;
            margin-top: 15px;
            padding-left: 10px;
          }
        }
      }
      .link-img {
        flex: 1;
        width: auto;
      }
      .title {
        text-align: left;
        // background-image: url(../assets/arrow_new.png);
        background-image: url(../assets/under_line.png);
        background-repeat: no-repeat;
        background-size: 100% auto;
        padding-left: 20px;
        line-height: 14px;
        min-height: 30px;
        font-size: 16px;
        font-weight: 500;
        color: #1d4f48;
      }
      p {
        text-align: left;
        padding: 10px 0;
        &.img {
          text-align: center !important;
        }
      }
      img {
        margin: 10px auto;
        width: calc(100% * (240 / 375));
      }
    }
  }
}

// .footer {
//   border-bottom: 15px solid #686767;
//   position: relative;
//   bottom: 0;
//   .top {
//     height: 10px;
//     background: url(../assets/main/footer_bg.png) repeat-x;
//     background-size: 15%;
//   }
//   .content {
//     display: flex;
//     margin: 30px 12%;
//     .qr {
//       flex: 0 1 30%;
//       margin-right: 10px;
//       img {
//         width: 100px;
//       }
//     }
//     .info {
//       flex: 1 0 70%;
//       font-size: 10px;
//       text-align: left;
//       padding-left: 10px;
//       margin-top: 3px;
//       box-sizing: border-box;
//       h5 {
//         font-size: 11px;
//         color: #1d4f48;
//       }
//       p {
//         line-height: 20px;
//         margin-bottom: 0;
//       }
//     }
//   }
// }
strong {
  font-weight: 700;
  display: block;
  margin-bottom: 15px;
  line-height: 20px;
}
</style>
